export default "__VITE_ASSET__6a073eec__"